// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import MFAModal from 'Containers/MFA/MFAModal';

const StyledMFAPage = styled.div`
  width: 100vw;
  height: 100vh;
`;

const MFAPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let MFAPageClassName = bodyAttributes?.class || '';
  if (!MFAPageClassName.includes('MFAPage')) {
    MFAPageClassName += 'MFAPage';
  }

  return (
    <>
      <Helmet>
        <body className={ MFAPageClassName } />
        <title>{ t('common.pages.mfa') }</title>
      </Helmet>
      <StyledMFAPage theme={ theme } className="grid-container">
        <MFAModal />
      </StyledMFAPage>
    </>
  );
});
MFAPage.displayName = 'MFAPage';

export default MFAPage;
